import { useSelector } from "react-redux";

import { FabrixIcon } from "../common";
import { IconsState } from "../redux/icons-slice";
import { AppState } from "../redux/store";

/**
 * Returns a lookup function for resolving icon class names by identifier.
 * @returns Function that maps a Fabrix icon name to its CSS class.
 */
export function useIcon() {

    const _iconState = useSelector<AppState>(state => state.icons) as IconsState;
  

    /**
     * Resolves a registered icon key to its CSS class for rendering.
     * @param name - Icon identifier or custom key.
     * @returns Matching CSS class name or undefined when not found.
     */
    const getIcon = (name: FabrixIcon | string) => {
        let className = _iconState.icons[name];
        return className;

    }

    return getIcon;

}



